import { state } from '@angular/animations';
import { Action, createSelector } from '@ngrx/store';

import * as messageActions from '../actions/message-actions';
import { Message, MessageType } from './../../message';

export type State = Message[];

const initialState: State = [];

export default function(state = initialState, action: messageActions.Actions): State {
  switch (action.type) {
    case messageActions.ADD_MESSAGE: {
      return [...state, action.payload];
    }
    case messageActions.REMOVE_MESSAGE: {
      return state.filter(message => message !== action.payload);
    }
    case messageActions.CLEAR_MESSAGES: {
      if (action.payload) {
        return state.filter(message => message.type !== action.payload);
      } else {
        return [];
      }
    }
    default: {
      return state;
    }
  }
}
